import React from 'react';
import PropTypes from 'prop-types';
import BaseComponent from "core/gd-components/base-component/base-component";

import FormManager from 'src/core/gd-form/common/form-manager';

import Textarea from 'core/gd-form/form-element/textarea/textarea';

import ButtonDeprecated from "core/gd-components/buttons/gd-button/gd-button";

export default class TextEditPopoverForm extends BaseComponent {
    static propTypes = {
        text: PropTypes.string,

        onSave: PropTypes.func
    };

    constructor(props) {
        super(props);

        const initFormData = {
            text: props.text
        };

        const formStructure = {
            fields: {
                text: {
                    type: 'input',
                    isRequired: false
                }
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        if(this.props.onSave) this.props.onSave(result.text);
    };

    render() {
        return (
            <div className="text-edit-form">
                <Textarea className="text-edit-form-textarea"
                          size="big"
                          form={this.form}
                          name="text"
                          noResizeControl={true}/>

                <ButtonDeprecated className="text-edit-form-submit-button min-width-90"
                                  type='primary'
                                  size="30"
                                  label="Save"
                                  onClick={()=>this.form.onSubmitClick()}/>

                <div className="cf"/>
            </div>
        );
    }
}